import type { UserProfile } from "@/services/authService";
import { Role } from "@/types/user";
import { hasRole, isRapidPlan } from "@/utils/accessControl";

export const ROOMS_NAV_HREF = "/reservations/rooms";

/**
 * Rooms (F7. Hotel: Rooms) is not part of the Rapid plan, so Hotel Admin and
 * Front Desk do not get the menu item there. Menu only: route and server
 * permissions are unchanged.
 */
export const isRoomsNavHiddenForPlan = (
  href: string,
  userProfile: UserProfile | null,
): boolean =>
  href === ROOMS_NAV_HREF &&
  isRapidPlan(userProfile) &&
  (hasRole(userProfile, Role.HOTEL_ADMIN) ||
    hasRole(userProfile, Role.FRONT_DESK));
